import { ClipboardList, FileText, ShieldCheck, BookOpen, Table2 } from "lucide-react";

export const tools = [
  {
    icon: ClipboardList,
    title: "Clinical Assessment Frameworks",
    body: "Structured worksheets for organizing patient history, relevant assessment information, and questions requiring further review.",
  },
  {
    icon: FileText,
    title: "Patient Documentation Templates",
    body: "Templates for recording patient information, treatment details, follow-up observations, and relevant communications.",
  },
  {
    icon: ShieldCheck,
    title: "Clinical Safety Review Checklists",
    body: "Educational checklists to help organize preparation, documentation, and safety-related considerations.",
  },
  {
    icon: BookOpen,
    title: "Educational Case Studies",
    body: "Hypothetical scenarios for reviewing clinical concepts, discussing warning signs, and examining the reasoning involved in different presentations.",
  },
  {
    icon: Table2,
    title: "Comparative Reference Tables",
    body: "Organized summaries that help you compare relevant educational concepts without repeatedly searching through disconnected materials.",
  },
];
